<template>
    <el-form ref="form" label-width="70px" :inline="true" class="login-container" :model="form" :rules="rules">
        <h3 class="login_title">系统登录</h3>
        <el-form-item label="用户名" prop="username">
            <el-input v-model="form.username" placeholder="请输入账号" @keyup.enter.native="submit"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
            <el-input type="password" v-model="form.password" placeholder="请输入密码" @keyup.enter.native="submit" show-password></el-input>
        </el-form-item>
        <el-form-item>
            <el-button @click="submit" type="primary" :loading="loading">登录</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    import Cookie from 'js-cookie'
    import { login } from '../api'

    export default {
        data () {
            return {
                loading: false,
                form: {
                    username: '',
                    password: ''
                },
                rules: {
                    username: [
                        { required: true, trigger: 'blur', message: '请输入用户名' }
                    ],
                    password: [
                        { required: true, trigger: 'blur', message: '请输入密码' }
                    ]
                }
            };
        },

        methods: {
            // 登录
            submit () {
                // token信息
                //const token = "1234";
                // 将token 信息存入cookie，用于页面间通信
                //Cookie.set('token', token);

                // 校验form表单
                console.log('ref', this.$refs.form)
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        console.log('login valid')
                        login(this.form).then(({ data }) => {
                            console.log('login response data', data)
                            if (data.code === 200) {
                                Cookie.set('token', data.data.jwt_token);
                                this.$store.commit('username', this.form.username);
                                this.loading = true
                                setTimeout(() => {
                                    if (this.$store.state.user.authAcc.includes(this.$store.state.user.username)) {
                                        this.$router.push('/belt');
                                    } else {
                                        // 跳转到首页
                                        this.$router.push('/home');
                                    }
                                }, 1000)
                            } else {
                                this.$message.error('用户名或密码错误')
                            }
                        });
                    } else {
                        this.$message.error('登录用户名和密码格式错误');
                    }
                })
            }
        }
    }
</script>

<stype lang="less" scoped>
    .login-container {
        width: 350px;
        border: 1px solid #eaeaea;
        margin: 180px auto;
        padding: 35px 35px 15px 35px;
        background-color: #fff;
        border-radius: 15px;
        box-shadow: 0 0 25px #cac6c6;
        box-sizing: border-box;

        .login_title {
            text-align: center;
            margin-bottom: 40px;
            color: #505458;
        }
        .el-input {
            width: 198px;
        }
        .el-button {
            margin-left: 105px;
            margin-top: 10px;
        }
    }
</stype>